// error messages from service_authorization_cap_rules
// eslint-disable-next-line max-len
export var UTILIZATION_ERROR = 'The client is already receiving this service through either a passthrough or non-passthrough service within this program group.';
// eslint-disable-next-line max-len
export var DATES_ERROR = 'Clients can only receive services from this program for 30 days or until their social coverage ends, whichever comes first.';
//# sourceMappingURL=messageConstants.js.map